module.exports = __webpack_public_path__ + "img/broadcast-tiao-icon3.6aebe00e.png";